/* eslint-disable */
import { SIDEBAR_TOGGLE } from '../Sidebar.types';

/**
 * Toggle whether or not the sidebar is open
 * @returns {ActionCreator<FromPayload<null, {}, SIDEBAR_TOGGLE>>} The created `Action`
 */
const sidebarToggle = () => ({ fromPayload }) => {
  return fromPayload(null, {}, SIDEBAR_TOGGLE);
};

export default sidebarToggle;
